import player from 'lottie-web';

export function playerFactory() {
  return player;
}
